// @flow
const AppConfig = () => {
  // $FlowFixMe
  const { default: hetoConfig } = require(`./${process.env.REACT_APP_ENV}`);
  return hetoConfig;
};

export default AppConfig;
